import * as ActionTypes from "constants/ActionTypes";

export function storyPublishSettingsLoaded(settings) {
  return {
    type: ActionTypes.STORY_PUBLISH_SETTINGS_LOADED,
    settings,
  };
}
